import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import USWarehouse from "@/pages/USWarehouse";
import Planning from "@/pages/Planning";
import UKWarehouse from "@/pages/UKWarehouse";
import FBATeam from "@/pages/FBATeam";
import Admin from "@/pages/Admin";
import { SCREEN_PATHS, hasScreen } from "@/constants/screens";

function ScreenRoute({ children, screen }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (!hasScreen(user, screen)) return <Navigate to={SCREEN_PATHS.dashboard} replace />;
  return children;
}

function DefaultRedirect() {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<DefaultRedirect />} />
              <Route element={<Layout />}>
                <Route path={SCREEN_PATHS.dashboard} element={<ScreenRoute screen="dashboard"><Dashboard /></ScreenRoute>} />
                <Route path={SCREEN_PATHS.sender_warehouse} element={<ScreenRoute screen="sender_warehouse"><USWarehouse /></ScreenRoute>} />
                <Route path={SCREEN_PATHS.planning} element={<ScreenRoute screen="planning"><Planning /></ScreenRoute>} />
                <Route path={SCREEN_PATHS.receiver_warehouse} element={<ScreenRoute screen="receiver_warehouse"><UKWarehouse /></ScreenRoute>} />
                <Route path={SCREEN_PATHS.marketplace_amazon_fba} element={<ScreenRoute screen="marketplace_amazon_fba"><FBATeam /></ScreenRoute>} />
                <Route path={SCREEN_PATHS.admin} element={<ScreenRoute screen="admin"><Admin /></ScreenRoute>} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
